/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountInfo.defs.js'
export * as $defs from './getAccountInfo.defs.js'
